import { gql } from '@apollo/client';
import { GqlProgram, GqlProgramFragment } from '../fragments/program';

export interface Input {
  ageDemographic: string;
  description: string;
  isCoed: boolean;
  name: string;
  id: number;
  sport: number;
}

export interface Data {
  updateProgram: GqlProgram;
}

export const MUTATION = gql`
  mutation UpdateProgram(
    $id: Int!
    $ageDemographic: String
    $description: String
    $isCoed: Boolean
    $name: String!
    $sportId: Int
    $areaOfOperation: Int
    $ageDivisions: [Int]
    $competitionGenders: [Int]
    $competitionLevels: [Int]
    $type: String
  ) {
    updateProgram(
      id: $id
      ageDemographic: $ageDemographic
      description: $description
      isCoed: $isCoed
      name: $name
      sportId: $sportId
      areaOfOperation: $areaOfOperation
      ageDivisions: $ageDivisions
      competitionGenders: $competitionGenders
      competitionLevels: $competitionLevels
      type: $type
    ) {
      ...ProgramFields
    }
  }
  ${GqlProgramFragment}
`;
